/**
 * 課程等級後端對應代碼列舉
 */
export enum CourseLevelCodeEnum {
  PreA1 = 0,
  A1 = 1,
  A2 = 2,
  B1 = 3,
  B2 = 4,
  C1 = 5,
  C2 = 6
}

/**
 * 使用者程度等級篩選項目
 */
export const courseLevelOption = {
  My: 999,
  All: -1,
  PreA1: 0,
  A1: 1,
  A2: 2,
  B1: 3,
  B2: 4,
  C1: 5
} as const;

export type CourseLevelOption = (typeof courseLevelOption)[keyof typeof courseLevelOption];

/**
 * 所有程度等級清單
 */
export const allLevels: CourseLevelOption[] = [
  courseLevelOption.PreA1,
  courseLevelOption.A1,
  courseLevelOption.A2,
  courseLevelOption.B1,
  courseLevelOption.B2,
  courseLevelOption.C1
];

/**
 * 使用者程度等級篩選標籤
 */
export const courseLevelOptionLabel: Record<CourseLevelOption, string> = {
  [courseLevelOption.My]: 'My Level',
  [courseLevelOption.All]: 'All',
  [courseLevelOption.PreA1]: 'pre-A1',
  [courseLevelOption.A1]: 'A1',
  [courseLevelOption.A2]: 'A2',
  [courseLevelOption.B1]: 'B1',
  [courseLevelOption.B2]: 'B2',
  [courseLevelOption.C1]: 'C1'
};

/**
 * 使用者程度等級清單對應格式轉換
 *
 * @remarks 將使用者等級轉換為後端等級清單格式
 * @example 後端格式: [1, 2, 3]
 */
export const courseLevelsMap = [
  {
    key: 'pre-A1',
    value: [0, 1],
    returnVal: [courseLevelOption.PreA1, courseLevelOption.A1]
  },
  {
    key: 'A1-1',
    value: [1, 1],
    returnVal: [courseLevelOption.PreA1, courseLevelOption.A1, courseLevelOption.A2]
  },
  {
    key: 'A1-2',
    value: [1, 2],
    returnVal: [courseLevelOption.PreA1, courseLevelOption.A1, courseLevelOption.A2]
  },
  {
    key: 'A1-3',
    value: [1, 3],
    returnVal: [courseLevelOption.PreA1, courseLevelOption.A1, courseLevelOption.A2]
  },
  {
    key: 'A2-1',
    value: [2, 1],
    returnVal: [courseLevelOption.PreA1, courseLevelOption.A1, courseLevelOption.A2]
  },
  {
    key: 'A2-2',
    value: [2, 2],
    returnVal: [courseLevelOption.PreA1, courseLevelOption.A1, courseLevelOption.A2]
  },
  {
    key: 'A2-3',
    value: [2, 3],
    returnVal: [courseLevelOption.A1, courseLevelOption.A2, courseLevelOption.B1]
  },
  {
    key: 'A2-4',
    value: [2, 4],
    returnVal: [courseLevelOption.A1, courseLevelOption.A2, courseLevelOption.B1]
  },
  {
    key: 'B1-1',
    value: [3, 1],
    returnVal: [
      courseLevelOption.A2,
      courseLevelOption.B1,
      courseLevelOption.B2,
      courseLevelOption.C1
    ]
  },
  {
    key: 'B1-2',
    value: [3, 2],
    returnVal: [
      courseLevelOption.A2,
      courseLevelOption.B1,
      courseLevelOption.B2,
      courseLevelOption.C1
    ]
  },
  {
    key: 'B1-3',
    value: [3, 3],
    returnVal: [
      courseLevelOption.A2,
      courseLevelOption.B1,
      courseLevelOption.B2,
      courseLevelOption.C1
    ]
  },
  {
    key: 'B1-4',
    value: [3, 4],
    returnVal: [courseLevelOption.B1, courseLevelOption.B2, courseLevelOption.C1]
  },
  {
    key: 'B1-5',
    value: [3, 5],
    returnVal: [courseLevelOption.B1, courseLevelOption.B2, courseLevelOption.C1]
  },
  {
    key: 'B2-1',
    value: [4, 1],
    returnVal: [courseLevelOption.B1, courseLevelOption.B2, courseLevelOption.C1]
  },
  {
    key: 'B2-2',
    value: [4, 2],
    returnVal: [courseLevelOption.B1, courseLevelOption.B2, courseLevelOption.C1]
  },
  {
    key: 'B2-3',
    value: [4, 3],
    returnVal: [courseLevelOption.B1, courseLevelOption.B2, courseLevelOption.C1]
  },
  {
    key: 'B2-4',
    value: [4, 4],
    returnVal: [courseLevelOption.B1, courseLevelOption.B2, courseLevelOption.C1]
  },
  {
    key: 'B2-5',
    value: [4, 5],
    returnVal: [courseLevelOption.B1, courseLevelOption.B2, courseLevelOption.C1]
  },
  {
    key: 'B2-6',
    value: [4, 6],
    returnVal: [courseLevelOption.B1, courseLevelOption.B2, courseLevelOption.C1]
  },
  {
    key: 'C1-1',
    value: [5, 1],
    returnVal: [courseLevelOption.B1, courseLevelOption.B2, courseLevelOption.C1]
  },
  {
    key: 'C1-2',
    value: [5, 2],
    returnVal: [courseLevelOption.B1, courseLevelOption.B2, courseLevelOption.C1]
  },
  {
    key: 'C1-3',
    value: [5, 3],
    returnVal: [courseLevelOption.B1, courseLevelOption.B2, courseLevelOption.C1]
  },
  {
    key: 'C1-4',
    value: [5, 4],
    returnVal: [courseLevelOption.B1, courseLevelOption.B2, courseLevelOption.C1]
  },
  {
    key: 'C1-5',
    value: [5, 5],
    returnVal: [courseLevelOption.B1, courseLevelOption.B2, courseLevelOption.C1]
  },
  {
    key: 'C1-6',
    value: [5, 6],
    returnVal: [courseLevelOption.B1, courseLevelOption.B2, courseLevelOption.C1]
  }
];
